import { StatModule } from "@/core/modules/stat/objects/StatModule";

import ItemCodeView from "./views/ItemCodeView.vue";

export const itemCode: StatModule = new StatModule("warehouse", "ItemCode", "warehouseStat", ItemCodeView);
